<rt-table variant="wide">
  <thead>
    <tr>
      <th class="th-name" text-left>
        {{ title() }}
      </th>
      @for (type of types(); track trackByType($index, type)) {
        <th class="th-type">
          {{ typeTranslations[type] }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    <ng-content />
  </tbody>
</rt-table>
